import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { navigate, useLocation } from "@reach/router";
import EsignInService from "../../../../services/EsignInService";

const EsignFianl = () => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useLocation();
  const queryParams = new URLSearchParams(history.search);
  const base64Id = queryParams.get("data");
  const uniqueId = queryParams.get("uniqueId");
  const arbitratorId = localStorage.getItem("arbitratorId");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (base64Id === "error") {
          const response = await EsignInService.getBase64(uniqueId);
          await EsignInService.updateEsignedFile(arbitratorId, {
            eSignedFile: "",
            Referencenumber: response?.decryptedData?.Referencenumber,
            Transactionnumber: response?.decryptedData?.Transactionnumber,
          });
          await EsignInService.clearBase64({
            base64Id: uniqueId,
          });
          navigate("/");
        } else {
          const response = await EsignInService.getBase64(base64Id);
          await EsignInService.updateEsignedFile(arbitratorId, {
            eSignedFile: response.decryptedData?.eSignedFile,
            Referencenumber: response.decryptedData?.Referencenumber,
            Transactionnumber: response.decryptedData?.Transactionnumber,
            signedDate: response.decryptedData?.signedDate,
          });
          await EsignInService.clearBase64({ base64Id: base64Id });
        }
      } catch (error) {
        console.error("Error:", error.response);
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        navigate("/");
      } finally {
        localStorage.removeItem("arbitratorId");
        navigate("/");
      }
    };
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <></>;
};

export default EsignFianl;
